<template>
  <el-dialog :title="$t('api.actions.downloadMulti.dialog.title')"
    :visible.sync="visible"
    custom-class="rwd-dialog">
    <el-form
      label-position="top"
      :model="formData"
      ref="formData"
    >
      <slot fields
        :data="formData"
      >
      </slot>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button
        @click="visible = false">
        {{ $t('api.cancelBtn') }}
      </el-button>
      <el-button type="primary"
        @click="save"
        :loading="loading"
        :disabled="ids.length <= 0"
      >
        {{ $t('api.actions.downloadMulti.saveBtn') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: 'multi-download-dialog',
  props: {
    downloadMulti: {
      type: Function,
      required: true
    },
    formData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      formValid: () => {},
      ids: [],
      loading: false,
      visible: false
    }
  },
  mounted () {
  },
  methods: {
    save () {
      this.downloadMulti(this.ids)
    },
    show (vals) {
      this.ids = []
      if (vals.length > 0) {
        this.ids = vals
      }
      this.visible = true
    },
    hide () {
      this.visible = false
    }
  },
  watch: {}
}
</script>
